import api from '../api/axios';

export interface Product {
  id?: number;
  name: string;
  description?: string;
  sku: string;
  barcode?: string;
  category?: number;
  price: number;
  cost?: number;
  currency?: string;
  unit?: 'piece' | 'kg' | 'liter' | 'meter' | 'box' | 'pack';
  weight?: number;
  dimensions?: string;
  minStockLevel?: number;
  isActive?: boolean;
  supplier?: number;
}

const ProductService = {
  getAll: (params?: any) => api.get('/products', { params }),
  getOne: (id: number) => api.get(`/products/${id}`, { params: { populate: '*' } }),
  create: (data: Product, params?: { locale?: string }) =>
    api.post('/products', { data }, { params: { locale: params?.locale || 'en' } }),
  update: (id: number, data: Partial<Product>, params?: { locale?: string }) =>
    api.put(`/products/${id}`, { data }, { params: { locale: params?.locale || 'en' } }),
  delete: (id: number) => api.delete(`/products/${id}`),
  getByCategory: (categoryId: number, params?: any) =>
    api.get('/products', {
      params: { ...params, 'filters[category][id][$eq]': categoryId },
    }),
};

export default ProductService;

